const padInteger = (number, size) => {
    let value = String(number);
    while (value.length < size)
        value = `0${value}`;
    return value;
};
export function normalizeDateOnly(value) {
    if (!value) {
        return null;
    }
    const date = value instanceof Date ? new Date(value.getTime()) : new Date(String(value));
    if (Number.isNaN(date.getTime())) {
        return null;
    }
    date.setHours(0, 0, 0, 0);
    return date;
}
export function isSameCalendarDay(dateA, dateB) {
    return dateA.getFullYear() === dateB.getFullYear()
        && dateA.getMonth() === dateB.getMonth()
        && dateA.getDate() === dateB.getDate();
}
export function getDateTimeString(date) {
    return `${date.getFullYear()}-${padInteger(date.getMonth() + 1, 2)}-${padInteger(date.getDate(), 2)} ${padInteger(date.getHours(), 2)}:${padInteger(date.getMinutes(), 2)}:${padInteger(date.getSeconds(), 2)}`;
}
export function getDateString(date, showTime) {
    if (!date) {
        return null;
    }
    if (showTime) {
        return getDateTimeString(date);
    }
    return `${date.getFullYear()}-${padInteger(date.getMonth() + 1, 2)}-${padInteger(date.getDate(), 2)}`;
}
export function formatTypedDateValue(value) {
    const date = normalizeDateOnly(value);
    return date ? getDateString(date, false) || "" : "";
}
export function formatTypedDateInput(value) {
    const digits = String(value || "").replace(/\D/g, "").slice(0, 8);
    const year = digits.slice(0, 4);
    const month = digits.slice(4, 6);
    const day = digits.slice(6, 8);
    return [year, month, day].filter(Boolean).join("-");
}
export function clampNumber(value, min, max) {
    if (!Number.isFinite(value)) {
        return min;
    }
    return Math.min(max, Math.max(min, value));
}
export function getDaysInMonth(year, month) {
    return new Date(year, month, 0).getDate();
}
export function defaultDateTime(date, isStart) {
    const value = isStart
        ? date.setHours(0, 0, 0)
        : date.setHours(23, 59, 59);
    return new Date(value);
}
export function parseTypedDate(value, isStart) {
    if (!value) {
        return null;
    }
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
    if (!match) {
        return null;
    }
    const year = Number(match[1]);
    const month = clampNumber(Number(match[2]), 1, 12);
    const day = clampNumber(Number(match[3]), 1, getDaysInMonth(year, month));
    if (!Number.isFinite(year) || !Number.isFinite(month) || !Number.isFinite(day)) {
        return null;
    }
    return defaultDateTime(new Date(year, month - 1, day), isStart);
}
export function parsePartialTypedDate(value, isStart) {
    const digits = value.replace(/\D/g, "").slice(0, 8);
    if (digits.length < 4) {
        return null;
    }
    const today = new Date();
    const year = Number(digits.slice(0, 4));
    const month = digits.length >= 6
        ? clampNumber(Number(digits.slice(4, 6)), 1, 12)
        : today.getMonth() + 1;
    const day = digits.length >= 8
        ? clampNumber(Number(digits.slice(6, 8)), 1, getDaysInMonth(year, month))
        : isStart ? 1 : getDaysInMonth(year, month);
    if (!Number.isFinite(year) || !Number.isFinite(month) || !Number.isFinite(day)) {
        return null;
    }
    return defaultDateTime(new Date(year, month - 1, day), isStart);
}
export function getAdjacentCalendarMonth(date, offset) {
    return new Date(date.getFullYear(), date.getMonth() + offset, 1);
}
export function formatCalendarMonthLabel(date) {
    return date.toLocaleDateString("en-US", {
        month: "long",
        year: "numeric",
    });
}
export function formatPickerLabel(date) {
    return date.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
    });
}
export function getCalendarMonthDays(monthDate) {
    const firstOfMonth = new Date(monthDate.getFullYear(), monthDate.getMonth(), 1);
    const gridStart = new Date(firstOfMonth);
    gridStart.setDate(firstOfMonth.getDate() - firstOfMonth.getDay());
    return Array.from({ length: 42 }, (_, index) => {
        const date = new Date(gridStart);
        date.setDate(gridStart.getDate() + index);
        const dateValue = getDateString(date, false) || "";
        return {
            dateValue,
            label: date.getDate(),
            ariaLabel: formatPickerLabel(date),
            isCurrentMonth: date.getMonth() === monthDate.getMonth(),
            isToday: isSameCalendarDay(date, new Date()),
        };
    });
}
